import React, { useState } from 'react';
import raidIcon from '../assets/raid_icon.png'; // Placeholder icon
import RaidModal from './RaidModal';

export default function RaidButton() {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                style={{
                    position: 'absolute',
                    top: 62,
                    right: 62,
                    zIndex: 1200,
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                }}
            >
                <div style={{ position: 'relative' }}>
                    <img src={raidIcon} alt="Raid" style={{ width: 70, height: 70 }} />

                </div>
            </button>
            <RaidModal open={open} onClose={() => setOpen(false)} />
        </>
    );
}
